// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { orderStatuses } from '../statuses';
import { OpenInNew } from '@mui/icons-material';

export default class PayoutOrdersPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'payoutOrders';
        this.Server = this.props.context.getState().server.payoutOrders;
        this.MenuDisplayType = 'menu';
        this.searchFields = [ 'uuid', 'payeeName', 'pmOrder', 'merchantOrder', 'email', 'phone', 'description', 'merchantTerminal.name',];
        this.exportButton = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'uuid',
                    label: 'uuid',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'merchantTerminalId',
                    label: 'merchantTerminal',
                    object: 'merchantTerminal',
                    show: 'name+merchantTerminalUuid',
                    from: 'publicMerchantTerminals',
                    alignRight: false,
                    cell: 'Select',
                    filterCell: 'Context',
                    filterBy: 'publicMerchantTerminals',
                    displayGrid: true
                },
                {
                    id: 'pmOrder',
                    label: 'pmOrder',
                    alignRight: false,
                    cell: 'Text',
                    // displayGrid: true,
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'merchantOrder',
                    label: 'merchantOrder',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'status',
                    label: 'status',
                    alignRight: false,
                    cell: 'State',
                    items: Object.keys(orderStatuses),
                    displayGrid: true,
                    filterCell: 'Items',
                    translate: 'enums'
                },
                {
                    id: 'amount',
                    label: 'amount',
                    alignRight: false,
                    cell: 'Amount',
                    displayGrid: true
                },
                {
                    id: 'description',
                    label: 'description',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'internalStateDescription',
                    label: 'internalStateDescription',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'email',
                    label: 'email',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'phone',
                    label: 'phone',
                    alignRight: false,
                    cell: 'Phone',
                    displayGrid: true
                },
                {
                    id: 'ip',
                    label: 'ip',
                    alignRight: false,
                    cell: 'Text',
                    // displayGrid: true,
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'ipMerchant',
                    label: 'ipMerchant',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'callbackUrl',
                    label: 'callbackUrl',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'pmComment',
                    label: 'pmComment',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true,
                },
                {
                    id: 'comment',
                    label: 'comment',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true,
                    disableSort: true,
                },
                {
                    id: 'createdType',
                    label: 'createdType',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'statusJson',
                    label: 'statusJson',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'Json'
                },
                {
                    id: 'totalIncludedCommission',
                    label: 'totalIncludedCommission',
                    alignRight: false,
                    cell: 'Amount',
                    displayGrid: true
                },
                {
                    id: 'totalOntopCommission',
                    label: 'totalOntopCommission',
                    alignRight: false,
                    cell: 'Amount',
                    displayGrid: true
                },
                {
                    id: 'payeeName',
                    label: 'payeeName',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'statusDesc',
                    label: 'statusDesc',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    renderCustomMenuItems() {
        return [
            <MenuItem key="showDetails" onClick={(event) => this.handleShowDialogDetails(event)}>
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>,
            <MenuItem
                key="goToPayoutInstances"
                onClick={(event) => this.handleGoToLinkedGrid(event, 'payout-instances', 'merchantOrder')}
            >
                <OpenInNew sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.goToPayoutInstances')}
            </MenuItem>,
        ];
    }
}
